import { AUTH_GET } from "@grudder/app/actions-client";
import { config } from "@grudder/lib/config";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const fetchUserOrganizations = createAsyncThunk("organization/get-user-organizations", async () => {
  try {
    //console.log("API Called")
    const response = await AUTH_GET(`${config.baseURL}/api/organizations/users/my-organizations`, {
      revalidate: 3600,
      tags: ["user-organizations"],
    });
    //console.log({ response })
    return response.data;
  } catch (error) {
    console.log({ error });
  }
});
